import React, { useEffect, useState } from "react";
import "./style.scss";
// import ZonePanel from "./ZonePanel";
// import { mainPageZones } from "./ZonesConstants";
import ReturnButton from "../../../features/ReturnButton";
import useFakeSession from "../../../utils/hooks/useFakeSession";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { useLocation } from "react-router";
import { logPageView } from "../../ga4/ga";
import ReactPixel from "react-facebook-pixel";
import PaymentSuccesModal from "../../../features/PaymentSuccessModal";
import ZonePanelClosed from "./ZonePanelClosed";
// import StartInfoPopUp from "../../../features/StartInfoPopUp";

const ZonesPage: React.FC = () => {
  useFakeSession();
  const isDesktop = useDesktopSize();
  const location = useLocation();

  useEffect(() => {
    logPageView();
    ReactPixel.pageView();
  }, [location]);

  useEffect(() => {
    window.parent.postMessage("scroll::", "*");
    window.parent.postMessage("resize::1500", "*");
    document.documentElement.scrollTop = 0;
  }, []);

  const [paymentSuccess, setPaymentSuccess] = useState(false);
  // const [startPopUp, setStartPopUp] = useState(true);

  useEffect(() => {
    setInterval(() => {
      const valuePaymentSuccess = sessionStorage.getItem("paymentSuccess");
      if (valuePaymentSuccess) {
        setPaymentSuccess(true);
      }
    }, 1000);
  }, []);

  const closePaymentSuccessModal = () => {
    sessionStorage.removeItem("paymentSuccess");
    setPaymentSuccess(false);
  };

  return (
    <div className={"zones-container"}>
      <div className={"zones-header"}>
        {isDesktop && (
          <ReturnButton onClick={() => window.parent.postMessage(`payU::https://www.julinek.com.pl`, "*")} />
        )}
        <p className={"zones-title"}>Wybierz strefę</p>
      </div>
      <div className={"zones-wrapper"}>
        {/*{mainPageZones.map((item, index) => (*/}
        {/*  <ZonePanel*/}
        {/*    key={index}*/}
        {/*    imgUrl={item.img}*/}
        {/*    title={item.title}*/}
        {/*    description={item.description}*/}
        {/*    attraction={item.attraction}*/}
        {/*    isInfoLimit={item.isInfoLimit}*/}
        {/*    classColor={item.classColor}*/}
        {/*    isSaleWithExercise={item.isSaleWithExercise}*/}
        {/*    titleButton={item.titleButton}*/}
        {/*    classButtonColor={item.classButtonColor}*/}
        {/*    pageUrl={item.pageUrl}*/}
        {/*    isDescription={item.isDescription}*/}
        {/*    isInfoPanel={item.isInfoPanel}*/}
        {/*    activeButton={item.activeButton}*/}
        {/*  />*/}
        {/*))}*/}
        <ZonePanelClosed />
      </div>
      {paymentSuccess && <PaymentSuccesModal open={paymentSuccess} closeModal={() => closePaymentSuccessModal()} />}
      {/*{startPopUp && <StartInfoPopUp open={startPopUp} closeModal={() => setStartPopUp(false)} />}*/}
    </div>
  );
};

export default ZonesPage;
